import { StoreFrontAPIConfig } from '@/shared/constants/shopify';
import { ensureTrailingSlash } from '@/shared/utils/urls';

/**
 * Ensures an explicit Storefront endpoint url
 * @param url Either raw Shopify domain, or an explicit graphql.json url
 * @returns Explicit graphql.json url
 */
export const ensureStorefrontEndpointUrl = (url: string) =>
  !url.endsWith('.json')
    ? `${ensureTrailingSlash(url)}api/${
        StoreFrontAPIConfig.VERSION
      }/graphql.json`
    : url;
